import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e251db0")

_pushScopeId("data-v-6e251db0")
const _hoisted_1 = { class: "relative inline-block" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-3 h-2 bg-white border-l border-t border-gray-200 transform rotate-45 translate-x-1 translate-y-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "p-3 border-b"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      ref: "triggerRef",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, undefined, true)
    ], 512),
    _createVNode(_Transition, { name: "fade-scale" }, {
      default: _withId(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              ref: "overlayRef",
              class: "absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border z-50",
              style: { width: _ctx.overlayWidth }
            }, [
              _createVNode("div", {
                class: `absolute -top-2 ${_ctx.arrowPosition} w-4 h-4 overflow-hidden`
              }, [
                _hoisted_2
              ], 2),
              (_ctx.$slots.header)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "header", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: `${_ctx.isContentHavePadding ? 'p-2' : ''}`
              }, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ], 2)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
})